import React from 'react';
import { useNavigate } from 'react-router-dom';
import DownloadTemplateButton from '../../DownloadTemplateButton'; 
import UploadSpreadsheetButton from '../../UploadSpreadsheetButton'; 
import imagePath from "../../assets/organizerDetails.jpg";
import EventName from '../../EventName'; 

const UploadMeetingSummary = ({ handleUploadSuccess, selectedFileName }) => {
  const navigate = useNavigate();
  const type = "meetingsummary";

  const styles = {
    container: {
      marginTop: '20px',
      marginLeft: '20px',
    },
    image: {
      width: '50%',
      height: 'auto',
    },
    buttons: {
      marginTop: '30px',
    },
   
  };

  
  const handleUploadSuccessWithNavigation = () => {
    handleUploadSuccess(); 
    navigate('/events/pre-event-planning/meeting-list'); 
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="White_Box">
            <div className="row">
              <div className="col-md-12">
                <EventName />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <img
                  src={imagePath}
                  style={styles.image}
                  alt="Organizer details"
                />
                <div style={styles.buttons}>
                  <DownloadTemplateButton downloadtype={type} />
                  <UploadSpreadsheetButton
                    uploadtype={type}
                    onUploadSuccess={handleUploadSuccessWithNavigation}
                    initialFileName={selectedFileName}
                  />
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadMeetingSummary;
